import theme from '../../themes/green';

const styles = {
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 200,
    position: 'relative',
  },
  focus: {
    transition: theme.transitions.slow,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: '2px solid transparent',
    pointerEvents: 'none',
    zIndex: 2,
  },
  focusActive: {
    border: `2px solid ${theme.pallete.color}`,
  },
  header: {
    background: theme.pallete.background,
    color: theme.pallete.lightTextColor,
    minHeight: 30,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0 10px',
  },
  title: {
    color: theme.pallete.lightTextColor,
    fontSize: 12,
    fontWeight: '600',
  },
  icon: {
    color: theme.pallete.lightTextColor,
    height: 13,
  },
  track: {
    width: 10,
    top: 0,
    right: 0,
    bottom: 0,
  },
  thumb: {
    background: theme.pallete.scrollbar,
  },
  contents: {},
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/EditorPanel/styles.js